module.exports = __webpack_public_path__ + "4eea100dab981175c53721895a01642c.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/svg/visaelectron.svg
// module id = 414
// module chunks = 0